import { PrivateBetaScreen } from './PrivateBetaScreen';

export const Authentication = () => {
  return (
    <PrivateBetaScreen
      icon="i-heroicons:shield-check"
      title="Secure your application"
      description="Configure sign-in methods, set up OAuth providers, and manage authentication settings for your users."
    />
  );
};
